import { styled } from "@linaria/react";
import { SIDE_PANEL_OPENED_CN, MEDIUM_LAYOUT_WIDTH_PX, SIDE_PANEL_WIDTH } from ".";

const SidePanelContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  &.${SIDE_PANEL_OPENED_CN} {
    @media (min-width: ${MEDIUM_LAYOUT_WIDTH_PX}px) {
      margin-right: ${SIDE_PANEL_WIDTH}px;
    }
  }
`;

export default SidePanelContent;
